import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { get, put, remove } from "../../../service/api";
import { SortableListBuilderColumns } from "../enum/list-builder-table-columns";
import { IListBuilderTableResponseDto } from "../interface/dto/list-builder-table-list.dto";

interface IFetchListBuildersTablePayload {
    limit?: number;
    offset?: number;
    id?: Array<number>;
    email?: string;
    query?: string;
    sortField?: SortableListBuilderColumns;
    sortDirection?: "asc" | "desc";
}

export const fetchListBuilders = (
    params: IFetchListBuildersTablePayload,
    tokens: ITokenPair,
): Observable<IListBuilderTableResponseDto> => {
    const queryParams = [
        params.limit !== undefined ? `limit=${params.limit}` : null,
        params.offset !== undefined ? `offset=${params.offset}` : null,
        ...(params.id?.map((id) => `id=${id}`) ?? []),
        params.email ? `email=${encodeURIComponent(params.email)}` : null,
        params.query ? `query=${encodeURIComponent(params.query)}` : null,
        params.sortField
            ? `sortField=${encodeURIComponent(params.sortField)}`
            : null,
        params.sortDirection ? `sortDirection=${params.sortDirection}` : null,
    ]
        .filter(Boolean)
        .join("&");

    return get<IListBuilderTableResponseDto>(
        `/list-builders?${queryParams}`,
        undefined,
        tokens,
    );
};

export const duplicateListBuilder = (
    id: number,
    tokens: ITokenPair,
    email?: string,
): Observable<{ success: boolean }> =>
    put<{ success: boolean }>(
        `/list-builders/${id}/duplicate`,
        undefined,
        email ? { email } : undefined,
        tokens,
    );

export const deleteListBuilder = (
    id: number,
    tokens: ITokenPair,
    email?: string,
): Observable<{ success: boolean }> =>
    remove<{ success: boolean }>(
        `/list-builders/${id}`,
        email ? { email } : undefined,
        tokens,
    );

export const buildListBuilder = (
    id: number,
    tokens: ITokenPair,
    email?: string,
): Observable<{ success: boolean }> =>
    put<{ success: boolean }>(
        `/list-builders/${id}/run`,
        undefined,
        email ? { email } : undefined,
        tokens,
    );

export const checkCreateListBuilderPermission = (
    tokens: ITokenPair,
): Observable<boolean> =>
    get<boolean>("/list-builders/can-create", undefined, tokens);
